import React from 'react';
import classNames from 'classnames';
import Link from '../general/Link';
import ArrowRightRound from '@/assets/arrowRightRound.svg';
import Stack from '../animation/Stack';
import { fadeInLeft, fadeInRight } from '@/animations';
import { NavigationInfoElementModel } from './MediaElement';
import Box from '../animation/Box';

type LinksBlockModel = {
  links: NavigationInfoElementModel[];
  alignment?: 'Left' | 'Right';
  backgroundColor?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const LinksBlock = ({ links, alignment, backgroundColor, className, ...props }: LinksBlockModel) => {
  if (!links) {
    return null;
  }

  const isText = links.some((link) => link.props.text);

  return (
    <Stack
      className={classNames(
        'links-block -ml-5 w-[calc(100%+40px)] md:-ml-10 md:w-[calc(100%+80px)] lg:ml-0 lg:w-full',

        className,
      )}
      {...props}
    >
      <div className="[&_.module-base-dark_.border-from-bg]:! flex flex-col">
        {links.map((link, index) => {
          return link.props.link ? (
            <Link
              animate
              animation={alignment === 'Left' ? fadeInRight : fadeInLeft}
              key={index}
              link={link.props.link}
              className={classNames(
                'color-from-bg group relative flex items-center justify-between gap-3 self-stretch p-3 transition-colors duration-500 md:py-4 xl:px-0',
                !backgroundColor || backgroundColor === '#ffffff' ? 'border-[#E9E9E9]' : 'border-from-bg',
                isText ? 'xl:py-5' : 'hover:bg-yellow focus:bg-yellow xl:py-7',
                index === 0 ? (isText ? '' : 'border') : isText ? 'after-extended-line-top' : 'border-x border-b',
              )}
            >
              {(link.props.title || link.props.text) && (
                <div className="xxl:gap-2 flex flex-col gap-2 lg:gap-1">
                  {link.props.title && (
                    <span
                      className={classNames('font-normal not-italic', isText ? 'text-style-h4' : 'text-xl sm:text-3xl')}
                    >
                      {link.props.title}
                    </span>
                  )}
                  {link.props.text && <span className="text-style-body hidden sm:block">{link.props.text}</span>}
                </div>
              )}
              <ArrowRightRound className="h-8 w-8 shrink-0 opacity-0 transition-all duration-500 group-hover:opacity-100 group-focus:opacity-100 md:h-10 md:w-10 pointer-coarse:hidden pointer-fine:block" />
            </Link>
          ) : (
            <Box
              key={index}
              animation={alignment === 'Left' ? fadeInRight : fadeInLeft}
              className={classNames(
                index === 0 && 'border-t',
                'mx-5 border-b py-5 text-3xl tracking-[-0.6px] md:mx-10 lg:mx-0',
              )}
            >
              {link.props.title}
            </Box>
          );
        })}
      </div>
    </Stack>
  );
};

export default LinksBlock;
